<template>
  <div>
    <Breadcrumbs title="Perfil de Usuario" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
     <div class="card mx-auto" v-if="usuario.id_rol == 5 || usuario.id_rol == 2 || usuario.id_rol == 1">
        <div class="row p-4">
          <div class="col-md-6">
            <h5>Perfil de Usuario <i class="fa fa-user"></i></h5>
            <hr />
            <p><strong>Usuario: </strong> {{ usuario.usr_usuario }}</p>
            <p><strong>Rol: </strong> {{ usuario.rol_rol }}</p>
            <p>
              <strong>Fecha de registro: </strong>
              {{ getDate(usuario.fecha_reg) }}
            </p>
            <hr />
            <p>
              <strong>Nro. Documento: </strong>
              {{ usuario.per_numero_documento }}
            </p>
            <p>
              <strong>Nombre Completo: </strong> {{ usuario.per_nombres }}
              {{ usuario.per_primer_apellido }}
              {{ usuario.per_segundo_apellido }}
            </p>
          </div>
          <div class="col-md-4">
            <h5>Cambiar Contraseña <i class="fa fa-key"></i></h5>
            <hr />
            <form @submit.prevent="cambiarPass">
              <div class="form-group">
                <label
                  >Contraseña actual:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.usr_password.required"
                  >
                    Campo requerido (*)
                  </span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Contraseña actual"
                  v-model.trim="usuario.usr_password"
                  :class="{
                    'is-invalid': submitted && $v.usuario.usr_password.$error,
                  }"
                />
              </div>
              <div class="form-group">
                <label
                  >Nueva contraseña:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.new_password.required"
                  >
                    Campo requerido (*)
                  </span>
                  <span
                    class="text-danger"
                    v-if="!$v.usuario.new_password.minLength"
                    >Al menos 7 caracteres
                  </span>
                </label>
                <password v-model="usuario.new_password" :toggle="true" />
              </div>
              <div class="form-group">
                <label
                  >Repita la nueva contraseña:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.confirm_password.required"
                    >Campo requerido (*)
                  </span>
                  <span
                    class="text-danger"
                    v-if="!$v.usuario.confirm_password.minLength"
                    >Al menos 7 caracteres </span
                  ><br />
                </label>
                <password v-model="usuario.confirm_password" :toggle="true" />
              </div>
              <button type="submit" class="btn btn-primary">
                <i class="fa fa-key"></i> Actualizar Contraseña
              </button>
            </form>
          </div>
        </div>
      </div>
      <div v-if="usuario.id_rol == 3 || usuario.id_rol == 4" >
        <div class="row p-4" >
          <div class="col-md-8">
             <div class="card">
                  <div class="card-header">
            <h5>Perfil de Usuario <i class="fa fa-user"></i></h5>
            <div class="row">
              <div class="col-md-6">
                <hr />
                <p><strong>Usuario: </strong> {{ usuario.usr_usuario }}</p>
                <p><strong>Rol: </strong> {{ usuario.rol_rol }}</p>
                <p>
                  <strong>Nombre Completo: </strong> {{ usuario.per_nombres }}
                  {{ usuario.per_primer_apellido }}
                  {{ usuario.per_segundo_apellido }}
                </p>
                
              </div>
              <div class="col-md-6">
                <hr />
                <p>
                  <strong>Tipo Documento: </strong>
                  {{ usuario.par_tipo_documento }}
                </p>
                <p>
                  <strong>Nro. Documento: </strong>
                  {{ usuario.per_numero_documento }}
                </p>
                <p>
                  <strong>Fecha de registro: </strong>
                  {{ getDate(usuario.fecha_reg) }}
                </p>
              </div>
            </div>
            <hr />
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="row mt-3">
                    <div class="col-12 col-md-12">
                      <div
                        class="alert alert-warning"
                        role="alert"
                        style="background-color: rgba(248, 214, 43, 0.1);color:#000;"
                      >
                        <i class="fa fa-exclamation-triangle"></i>
                        Actualice sus datos en caso de
                        tener dificultades comunicarse a:
                        <b>soportedgm@migracion.gob.bo</b>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    
                    <div class="col-12 col-md-4">
                      <label>
                        Fecha Nacimiento:
                        <span
                          class="text-danger lb-error"
                          v-if="!$v.usuario.per_fecha_nacimiento.required"
                          >* Campo requerido</span
                        >
                      </label>
                      <input
                        type="date"
                        class="form form-control"
                        :class="{
                          'is-invalid': $v.usuario.per_fecha_nacimiento.$error,
                        }"
                        v-model="usuario.per_fecha_nacimiento"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label
                        >Género:
                        <span
                          class="text-danger lb-error"
                          v-if="!$v.usuario.par_genero.required"
                          >Campo requerido</span
                        >
                      </label>
                      <select
                        class="custom-select"
                        :class="{ 'is-invalid': $v.usuario.par_genero.$error }"
                        v-model="usuario.par_genero"
                      >
                        <option value="">SELECCIONAR</option>
                        <option value="F">FEMENINO</option>
                        <option value="M">MASCULINO</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <label>Telefono:</label>
                      <span
                        class="text-danger lb-error"
                        v-if="!$v.usuario.per_telefono.numero"
                        >Solo debe ingresar Numeros</span
                      >
                      <input
                        type="number"
                        placeholder="ej: 2521585"
                        class="form-control"
                        v-model.trim="usuario.per_telefono"
                        @keyup="usuario.per_telefono = usuario.per_telefono"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-12 col-md-6">
                      <label>
                        Nacionalidad:
                        <span
                          class="text-danger lb-error"
                          v-if="!$v.usuario.par_nacionalidad.required"
                          >Campo requerido</span
                        >
                      </label>
                      <select
                        class="form form-control"
                        :class="{
                          'is-invalid': $v.usuario.par_nacionalidad.$error,
                        }"
                        v-model="usuario.par_nacionalidad"
                      >
                        <option
                          v-for="(item, index) in nacionalidades"
                          :key="index"
                          :value="item.a3_dgm"
                          >{{ item.nombre }}</option
                        >
                      </select>
                    </div>
                    <div class="col-12 col-md-6">
                      <label>Correo Electrónico:</label>
                      <input
                        type="email"
                        placeholder="Email..."
                        class="form form-control"
                        :class="{ 'is-invalid': $v.usuario.per_email.$error }"
                        v-model.trim="usuario.per_email"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    

                    
                  </div>
                </div>
                <div class="col-md-2"></div>

                <div class="col-md-4">
                  <!-- <a type="button" class="btn btn-secondary btn-block">
          <small>Cancelar</small></a> -->
                  <router-link to="inicio" class="btn btn-secondary btn-block"
                    ><small>Cancelar</small></router-link
                  >
                </div>
                <div class="col-md-4">
                  <a
                    type="button"
                    class="btn btn-primary btn-block"
                    @click="editar(usuario)"
                    ><small>Modificar</small></a
                  >
                </div>
              </div>
            </div>
          </div>
           </div>
          </div>
          <div class="col-md-4">
          <div class="card">
                  <div class="card-header">
            <h5>Cambiar Contraseña <i class="fa fa-key"></i></h5>
            <hr />
            <form @submit.prevent="cambiarPass">
              <div class="form-group">
                <label
                  >Contraseña actual:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.usr_password.required"
                  >
                    Campo requerido (*)
                  </span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Contraseña actual"
                  v-model.trim="usuario.usr_password"
                  :class="{
                    'is-invalid': submitted && $v.usuario.usr_password.$error,
                  }"
                />
              </div>
              <div class="form-group">
                <label
                  >Nueva contraseña:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.new_password.required"
                  >
                    Campo requerido (*)
                  </span>
                  <span
                    class="text-danger"
                    v-if="!$v.usuario.new_password.minLength"
                    >Al menos 7 caracteres
                  </span>
                </label>
                <password v-model="usuario.new_password" :toggle="true" />
              </div>
              <div class="form-group">
                <label
                  >Repita la nueva contraseña:
                  <span
                    class="text-danger text-help"
                    v-if="!$v.usuario.confirm_password.required"
                    >Campo requerido (*)
                  </span>
                  <span
                    class="text-danger"
                    v-if="!$v.usuario.confirm_password.minLength"
                    >Al menos 7 caracteres </span
                  ><br />
                </label>
                <password v-model="usuario.confirm_password" :toggle="true" />
              </div>
              <button type="submit" class="btn btn-primary">
                <i class="fa fa-key"></i> Actualizar Contraseña
              </button>
            </form>
          </div>
        </div>
        </div>
        </div>
      </div>
    </div>

    <!-- Container-fluid Ends-->
    <Loading v-if="cargando" />
  </div>
</template>

<script>
import { required, minLength, email, helpers } from "vuelidate/lib/validators";
import Loading from "../components/Loading";
import { mapState } from "vuex";
import Password from "vue-password-strength-meter";
import { mapActions } from "vuex";
import moment from "moment";
const numero = helpers.regex("alpha", /^[-1234567890]*$/);

export default {
  computed: {
    ...mapState(["token"]),
  },
  components: {
    Loading,
    Password,
  },
  data() {
    return {
      resultados: [],
      usuario: {
        usr_password: "",
        new_password: "",
        confirm_password: "",

        id_persona: "",
        // per_nombres: "",
        // per_primer_apellido: "",
        // per_segundo_apellido: "",
        par_tipo_documento: "",
        //per_numero_documento: "",
        per_fecha_nacimiento: "",
        par_genero: "",
        par_nacionalidad: "",
        per_telefono: "",
      },
      cargando: false,
      submitted: false,
      resultado: [],
      nacionalidades: [],
      tipoDocumentos: [],

      nocoincide: false,
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    ...mapActions(["cerrarSesion"]),
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async cambiarPass() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }
      this.cargando = true;
      try {
        this.resultado = await this.axios.put(`/usuario`, {
          usr_password: this.usuario.usr_password,
          new_password: this.usuario.new_password,
          confirm_password: this.usuario.confirm_password,
        });
       // console.log("Mensaje:", this.resultado.data.mensaje);

        this.$swal({
          title: "Información",
          text: this.resultado.data.mensaje,
          type: "info",
          confirmButtonText: "Aceptar",
        });

        this.cerrarSesion();
      } catch (error) {
        this.$swal({
          title: "Información",
          text: error.response,
          type: "info",
          confirmButtonText: "Aceptar",
        });
      }
      this.usuario = [];
      this.submitted = false;
      this.cargando = false;
    },
    async listarDatos() {
      let config = { headers: { token: this.token } };
      this.cargando = true;
      try {
        this.resultados = await this.axios.get(`/usuarioGetDataUser`, config);
        this.usuario = this.resultados.data.contenido;
        //console.log("Resultado",contenido);
        this.cargando = false;
      } catch (error) {
        console.log(error);
      }
    },
    async editar() {
     //console.log("contenido:", this.usuario);
      this.cargando = true;
      //revisar
      // this.$v.$touch();
      // if(this.$v.$invalid){
      //   this.cargando = false;
      //   return;
      // }

      try {
        let resultados = await this.axios.put(
          `/personaIndividual`,
          this.usuario
        );

        if (resultados.status == 200) {
          this.cargando = false;
          this.$swal({
            title: "Información",
            type: "success",
            html: `Modificación correcta.`,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          }).then(() => {
            this.listarDatos();
          });
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getNacionalidades() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios
          .get(`/parametrosPaises`, config)
          .then((response) => {
            this.nacionalidades = response.data.contenido;
          })
          .catch((error) => {
            console.log("catch: ", error);
          });
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getTipoDocumento() {
      try {
        let res = await this.axios.get(`/getParametros/DOCUMENTO`);
        this.tipoDocumentos = res.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
  },
  validations: {
    usuario: {
      usr_password: { required },
      new_password: { required, minLength: minLength(7) },
      confirm_password: { required, minLength: minLength(7) },

      // per_nombres: { required, letras },
      // per_primer_apellido: { required, letras },
      // per_segundo_apellido: { letras },
      per_telefono: { numero },
      par_tipo_documento: { required },
      // per_numero_documento: { required },
      per_fecha_nacimiento: { required },
      par_genero: { required },
      par_nacionalidad: { required },
      per_email: { email },
    },
  },
  created() {
    this.listarDatos();
    this.getTipoDocumento();
    this.getNacionalidades();
  },
};
</script>
<style>
.persona {
  color: rgb(229, 185, 33);
}
.iPersona {
  color: #000;
  font-size: 20px !important;
  font-weight: bold;
}
</style>
